import { render, staticRenderFns } from "./ReturnabilityByServiceGroup.vue?vue&type=template&id=56ecb3b0&scoped=true"
import script from "./ReturnabilityByServiceGroup.vue?vue&type=script&lang=js"
export * from "./ReturnabilityByServiceGroup.vue?vue&type=script&lang=js"
import style0 from "./ReturnabilityByServiceGroup.vue?vue&type=style&index=0&id=56ecb3b0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ecb3b0",
  null
  
)

export default component.exports